import Immutable from 'seamless-immutable'

import * as actions from './actions'

const initialState = Immutable.from({
  type: '',
  status: {},
})

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case actions.SET_VERIFICATION_STATUS:
      return state
        .setIn(['status', 'account'], payload?.account)
        .setIn(['status', 'session'], payload?.session)
    case actions.SET_VERIFICATION_TYPE:
      return state.set('type', payload.type)
    default:
      return state
  }
}
